import { defineComponent as i, inject as f, computed as d, h as a } from "vue";
import S from "./ghl-ui.es1553.js";
import { dataTableInjectionKey as p } from "./ghl-ui.es975.js";
import v from "./ghl-ui.es887.js";
import g from "./ghl-ui.es894.js";
import R from "./ghl-ui.es1421.js";
const O = i({
  name: "SortIcon",
  props: {
    column: {
      type: Object,
      required: !0
    }
  },
  setup(o) {
    const { mergedComponentPropsRef: e } = v(), { mergedSortStateRef: t, mergedClsPrefixRef: n } = f(p), m = d(() => t.value.find((r) => r.columnKey === o.column.key)), c = d(() => m.value !== void 0), l = d(() => {
      const { value: r } = m;
      return r && c.value ? r.order : !1;
    }), u = d(() => {
      var r, s;
      return ((s = (r = e == null ? void 0 : e.value) === null || r === void 0 ? void 0 : r.DataTable) === null || s === void 0 ? void 0 : s.renderSorter) || o.column.renderSorter;
    });
    return {
      mergedClsPrefix: n,
      active: c,
      mergedSortOrder: l,
      mergedRenderSorter: u
    };
  },
  render() {
    const { mergedRenderSorter: o, mergedSortOrder: e, mergedClsPrefix: t } = this, { renderSorterIcon: n } = this.column;
    return o ? a(S, { render: o, order: e }) : a("span", { class: [
      `${t}-data-table-sorter`,
      e === "ascend" && `${t}-data-table-sorter--asc`,
      e === "descend" && `${t}-data-table-sorter--desc`
    ] }, n ? n({ order: e }) : a(g, { clsPrefix: t }, { default: () => a(R, null) }));
  }
});
export {
  O as default
};
